import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('student-home', {
  key: 'student-home',
  label: 'Student Home',
  getSteps: () => [
    step({
      target: '#tour-student-home-cards',
      title: 'Welcome',
      content:
        'Snapshot of your school day — attendance summary and your subjects (or registered courses, if you\'re tertiary). Each card has a button to jump to the full module.',
      placement: 'bottom',
    }),
    step({
      target: '#app-tour-trigger',
      title: 'Replay Anytime',
      content:
        'Click this anywhere in the app to take a guided tour of the page you\'re on. The icon pulses when there\'s a tour you haven\'t seen yet.',
      placement: 'bottom',
    }),
  ],
});

registerTourPage('student-courses', {
  key: 'student-courses',
  label: 'Course Registration',
  getSteps: () => [
    introStep({
      title: 'Register for Courses',
      content:
        'Compulsory courses are pre-selected automatically. Add electives until you hit the maximum unit limit, then submit. You can resubmit later if registration is still open.',
    }),
  ],
});

registerTourPage('student-course-reg', {
  key: 'student-course-reg',
  label: 'Course Registration',
  getSteps: () => [
    introStep({
      title: 'Register for Courses',
      content:
        'Pick your courses for the term. The summary at the top tracks your unit count against the minimum and maximum allowed.',
    }),
  ],
});

registerTourPage('student-timetable', {
  key: 'student-timetable',
  label: 'Timetable',
  getSteps: () => [
    introStep({
      title: 'Your Class Schedule',
      content:
        'The week\'s timetable for your class. Click any cell to see the subject, staff, time, and any notes.',
    }),
  ],
});

registerTourPage('student-result', {
  key: 'student-result',
  label: 'Results',
  getSteps: () => [
    introStep({
      title: 'Your Results',
      content:
        'Term-by-term results, broken down by subject. You can switch sessions, view a printable copy, and (if your school allows) download a PDF.',
    }),
  ],
});

registerTourPage('student-cbt', {
  key: 'student-cbt',
  label: 'CBT',
  getSteps: () => [
    introStep({
      title: 'Computer-Based Tests',
      content:
        'Your active and upcoming tests. Click "Take Test" when one is available — once you start, the timer runs and you can\'t leave the test page until you submit or time runs out.',
    }),
  ],
});

registerTourPage('student-attendance', {
  key: 'student-attendance',
  label: 'Attendance',
  getSteps: () => [
    introStep({
      title: 'Your Attendance',
      content:
        'Counters at the top tally your present, absent, and late days. The calendar below shows each day colour-coded so you can spot patterns.',
    }),
  ],
});
